import { annotationPlugin } from "@features/custom-annotations";

import { chartDataManagerPlugin } from "./chart-data-manager-plugin";

export const plugins = [annotationPlugin, chartDataManagerPlugin];
